<template>
  <div>
    <b-alert v-if="error" variant="danger" show>{{error}}</b-alert>
  </div>
</template>

<script>
export default {
  name: 'Error',
  computed: {
    error () {
      if (this.$store.state.error ) {
        return this.$store.state.error;
      } else {
        return '';
      }
    }
  }

}
</script>

<style scoped>

</style>
